import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../../collections/ste/components/helper/constant";

const stateSlice = createSlice({
  name: "stateSlice",
  initialState: initialState,
  reducers: {
    handleInitialStateChange: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
  },
});

export const { handleInitialStateChange } = stateSlice.actions;

export default stateSlice.reducer;
